// mox-card.js
(function () {
  if (window.__moxCardSizesInit) return;
  window.__moxCardSizesInit = true;

  // Función helper para actualizar el precio según una variante
  function updatePriceForVariant(priceList, variant) {
    if (!priceList || !variant) return;
    
    const variantPrice = variant.price || 0;
    const variantComparePrice = variant.compare_at_price || 0;
    
    // Formatear precios
    const formatMoney = (cents) => {
      const currencyCode = window.Shopify?.currency?.active || 'EUR';
      return new Intl.NumberFormat('es-ES', {
        style: 'currency',
        currency: currencyCode
      }).format(cents / 100);
    };
    
    const salePriceElement = priceList.querySelector('sale-price');
    if (salePriceElement) {
      salePriceElement.textContent = formatMoney(variantPrice);
      if (variantComparePrice > variantPrice) {
        salePriceElement.className = salePriceElement.className.replace(/text-subdued/g, 'text-on-sale');
      } else {
        salePriceElement.className = salePriceElement.className.replace(/text-on-sale/g, 'text-subdued');
      }
    }

    let comparePriceElement = priceList.querySelector('compare-at-price');
    if (variantComparePrice > variantPrice) {
      if (!comparePriceElement) {
        comparePriceElement = document.createElement('compare-at-price');
        comparePriceElement.className = 'text-subdued line-through';
        if (salePriceElement) {
          salePriceElement.after(comparePriceElement);
        } else {
          priceList.appendChild(comparePriceElement);
        }
      }
      comparePriceElement.textContent = formatMoney(variantComparePrice);
      comparePriceElement.style.display = '';
    } else if (comparePriceElement) {
      comparePriceElement.style.display = 'none';
    }
  }

  // Función para detectar si estamos en móvil
  function isMobile() {
    return window.innerWidth <= 749;
  }

  // Función para desactivar todos los overlays excepto uno
  function deactivateAllOverlays(exceptCard) {
    document.querySelectorAll('product-card.mox-overlay-active').forEach(card => {
      if (card !== exceptCard) {
        card.classList.remove('mox-overlay-active');
      }
    });
  }

  // Función para manejar clics/touches en tarjetas de producto en móvil
  function handleCardInteraction(event) {
    if (!isMobile()) return;

    const productCard = event.target.closest('product-card');
    const overlay = productCard ? productCard.querySelector('.mox-card-size-overlay') : null;

    // Si el clic es fuera de cualquier tarjeta, desactivamos todos los overlays
    if (!productCard) {
      deactivateAllOverlays(null);
      return;
    }

    if (!overlay) return;

    // Verificar si el clic es en el inner del overlay o en un botón de talla
    const clickedOnInner = event.target.closest('.mox-card-size-overlay__inner');
    const clickedOnSizeButton = event.target.closest('.mox-card-size-overlay__size');
    
    // Si el clic es en el inner o en un botón, no hacer nada (dejar que funcionen normalmente)
    if (clickedOnInner || clickedOnSizeButton) {
      return;
    }
    
    // Verificar si el overlay ya está activo
    const isOverlayActive = productCard.classList.contains('mox-overlay-active');
    
    // Si el clic es en el link de la imagen o en la tarjeta
    const productLink = event.target.closest('a.product-card__media');
    const isCardClick = productLink || event.target.closest('.product-card__figure');

    if (isCardClick) {
      // Desactivar otros overlays
      deactivateAllOverlays(productCard);

      if (!isOverlayActive) {
        // Primer clic/touch: mostrar overlay y prevenir navegación
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
        productCard.classList.add('mox-overlay-active');
        return false;
      } else {
        // Segundo clic/touch: navegar al PDP INMEDIATAMENTE
        // Obtener la URL PRIMERO
        let targetUrl = null;
        const linkToUse = productLink || productCard.querySelector('a.product-card__media');
        if (linkToUse) {
          targetUrl = linkToUse.getAttribute('href');
        }
        
        // Prevenir el comportamiento por defecto y detener propagación
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
        
        // Remover la clase
        productCard.classList.remove('mox-overlay-active');
        
        // Navegar inmediatamente
        if (targetUrl) {
          // Forzar navegación inmediata
          window.location.assign(targetUrl);
        }
        return false;
      }
    } else {
      // Si el clic es en otra parte de la tarjeta (no en la imagen), desactivar overlay
      deactivateAllOverlays(null);
    }
  }

  // Manejo de eventos táctiles para iOS
  let touchStartTime = 0;
  let touchStartCard = null;
  let touchStartTarget = null;
  let touchHandled = false;
  
  document.addEventListener('touchstart', function (event) {
    if (!isMobile()) return;
    
    touchHandled = false;
    const productCard = event.target.closest('product-card');
    if (productCard) {
      const overlay = productCard.querySelector('.mox-card-size-overlay');
      if (overlay) {
        touchStartTime = Date.now();
        touchStartCard = productCard;
        touchStartTarget = event.target;
      }
    }
  }, { passive: true });
  
  // Manejo de eventos táctiles para iOS (touchend)
  document.addEventListener('touchend', function (event) {
    if (!isMobile() || touchHandled) return;
    
    if (touchStartCard && touchStartTarget) {
      const overlay = touchStartCard.querySelector('.mox-card-size-overlay');
      if (overlay) {
        const touchDuration = Date.now() - touchStartTime;
        // Solo procesar si el touch fue rápido (menos de 500ms) para evitar conflictos con scroll
        if (touchDuration < 500) {
          // Verificar si el touch es en el inner del overlay o en un botón de talla
          const clickedOnInner = touchStartTarget.closest('.mox-card-size-overlay__inner');
          const clickedOnSizeButton = touchStartTarget.closest('.mox-card-size-overlay__size');
          
          // Si el touch es en el inner o en un botón, no hacer nada
          if (!clickedOnInner && !clickedOnSizeButton) {
            // Verificar si el overlay ya está activo
            const isOverlayActive = touchStartCard.classList.contains('mox-overlay-active');
            
            // Si el touch es en el link de la imagen o en la tarjeta
            const productLink = touchStartTarget.closest('a.product-card__media');
            const isCardClick = productLink || touchStartTarget.closest('.product-card__figure');
            
            if (isCardClick) {
              // Prevenir el evento click que viene después
              event.preventDefault();
              event.stopPropagation();
              
              // Desactivar otros overlays
              deactivateAllOverlays(touchStartCard);
              
              if (!isOverlayActive) {
                // Primer touch: mostrar overlay
                touchStartCard.classList.add('mox-overlay-active');
                touchHandled = true;
              } else {
                // Segundo touch: navegar al PDP
                let targetUrl = null;
                const linkToUse = productLink || touchStartCard.querySelector('a.product-card__media');
                if (linkToUse) {
                  targetUrl = linkToUse.getAttribute('href');
                }
                
                // Remover la clase
                touchStartCard.classList.remove('mox-overlay-active');
                
                // Navegar inmediatamente
                if (targetUrl) {
                  touchHandled = true;
                  window.location.assign(targetUrl);
                }
              }
            }
          }
        }
      }
    }
    
    // Resetear
    touchStartCard = null;
    touchStartTarget = null;
  }, true); // Usar capture phase
  
  // Manejo de clics en tarjetas de producto en móvil (para navegadores que no son iOS o como fallback)
  document.addEventListener('click', function (event) {
    if (!isMobile()) return;
    
    // Si ya manejamos el touch, prevenir el click
    if (touchHandled) {
      event.preventDefault();
      event.stopPropagation();
      touchHandled = false;
      return false;
    }
    
    handleCardInteraction(event);
  }, true); // Usar capture phase para interceptar antes que otros handlers

  // Manejo de clic en botones de tamaño
  document.addEventListener('click', function (event) {
    const btn = event.target.closest('.mox-card-size-overlay__size');
    if (!btn) return;

    const form = btn.closest('form');
    if (!form) return;

    const idInput = form.querySelector('input[name="id"]');
    if (!idInput) return;

    // Actualizamos el hidden con la variante de ese botón
    idInput.value = btn.dataset.variantId;
  });

  // Manejo de selección de colores para compra rápida (inputs radio)
  document.addEventListener('change', function (event) {
    const colorInput = event.target.closest('input[type="radio"][data-color-value]');
    if (!colorInput) return;

    const productCard = colorInput.closest('product-card');
    if (!productCard) return;

    const variantId = colorInput.dataset.variantId;
    const variantImage = colorInput.dataset.variantImage;
    const selectedColor = colorInput.value;
    
    // Actualizar imagen del producto si hay variante con imagen
    if (variantImage && productCard) {
      const mainImage = productCard.querySelector('.product-card__image--primary');
      if (mainImage && mainImage.tagName === 'IMG') {
        mainImage.src = variantImage;
        mainImage.srcset = variantImage;
        // También actualizar la imagen secundaria si existe
        const secondaryImage = productCard.querySelector('.product-card__image--secondary');
        if (secondaryImage && secondaryImage.tagName === 'IMG') {
          // Intentar obtener la siguiente imagen de la variante
          const nextMedia = productCard.querySelector(`[data-variant-id="${variantId}"]`);
          if (nextMedia && nextMedia.dataset.variantSecondaryMedia) {
            try {
              const secondaryMedia = JSON.parse(nextMedia.dataset.variantSecondaryMedia);
              if (secondaryMedia && secondaryMedia.src) {
                secondaryImage.src = secondaryMedia.src;
                secondaryImage.srcset = secondaryMedia.srcset || secondaryMedia.src;
              }
            } catch (e) {
              // Ignorar errores de parsing
            }
          }
        }
      }
    }

    // Actualizar overlay de tamaños con las variantes disponibles para el color seleccionado
    const overlay = productCard.querySelector('.mox-card-size-overlay');
    if (overlay) {
      const form = overlay.querySelector('form');
      if (form) {
        const idInput = form.querySelector('.mox-variant-id-input');
        const sizeContainer = overlay.querySelector('[data-size-container]');
        
        if (sizeContainer) {
          // Ocultar/mostrar botones de tamaño según el color seleccionado
          const sizeButtons = sizeContainer.querySelectorAll('.mox-card-size-overlay__size');
          let firstAvailableVariantId = null;
          
          sizeButtons.forEach(btn => {
            const btnColorValue = btn.dataset.colorValue;
            if (btnColorValue === selectedColor) {
              btn.style.display = '';
              if (!firstAvailableVariantId) {
                firstAvailableVariantId = btn.dataset.variantId;
              }
            } else {
              btn.style.display = 'none';
            }
          });
          
          // Actualizar el input hidden con la primera variante disponible del color seleccionado
          if (idInput && firstAvailableVariantId) {
            idInput.value = firstAvailableVariantId;
          }
        } else if (idInput && variantId) {
          // Fallback: actualizar directamente con la variante del color
          idInput.value = variantId;
        }
      }
    }
  });

  // Manejo de clic en swatches de color (enlaces desde theme.fbt)
  document.addEventListener('click', function (event) {
    const colorSwatch = event.target.closest('a[data-color-swatch="true"]');
    if (!colorSwatch) return;

    // Prevenir navegación si hay JavaScript para actualizar el producto
    event.preventDefault();

    // Verificar si estamos en una tarjeta de producto o en la PDP
    const productCard = colorSwatch.closest('product-card');
    const isProductPage = !productCard && colorSwatch.closest('.product-info, .product');
    
    if (!productCard && !isProductPage) return;
    
    // Si estamos en la PDP, hacer fetch del producto completo y actualizar todo
    if (isProductPage) {
      const productUrl = colorSwatch.dataset.productUrl;
      if (!productUrl) {
        console.error('No product URL found');
        return;
      }
      
      // Remover clase is-selected de todos los swatches
      const allSwatches = document.querySelectorAll('a[data-color-swatch="true"]');
      allSwatches.forEach(swatch => swatch.classList.remove('is-selected'));
      
      // Agregar clase is-selected al swatch clickeado
      colorSwatch.classList.add('is-selected');
      
      // Mostrar indicador de carga
      const productRerender = document.querySelector('product-rerender');
      if (productRerender) {
        productRerender.style.opacity = '0.6';
        productRerender.style.pointerEvents = 'none';
      }
      
      // Hacer fetch del nuevo producto
      fetch(productUrl)
        .then(response => response.text())
        .then(html => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');
          
          // 1. Actualizar galería de imágenes completa
          const newGallery = doc.querySelector('product-gallery');
          const currentGallery = document.querySelector('product-gallery');
          if (newGallery && currentGallery) {
            currentGallery.innerHTML = newGallery.innerHTML;
            // Disparar evento para reinicializar la galería si es necesario
            currentGallery.dispatchEvent(new CustomEvent('gallery:update', { bubbles: true }));
          }
          
          // 2. Actualizar variant-picker completo
          const newVariantPicker = doc.querySelector('variant-picker');
          const currentVariantPicker = document.querySelector('variant-picker');
          if (newVariantPicker && currentVariantPicker) {
            // Guardar el form-id actual
            const formId = currentVariantPicker.getAttribute('form-id');
            const sectionId = currentVariantPicker.getAttribute('section-id');
            const context = currentVariantPicker.getAttribute('context');
            const handle = currentVariantPicker.getAttribute('handle');
            const updateUrl = currentVariantPicker.hasAttribute('update-url');
            
            // Reemplazar el contenido pero mantener los atributos
            currentVariantPicker.innerHTML = newVariantPicker.innerHTML;
            currentVariantPicker.setAttribute('form-id', formId);
            currentVariantPicker.setAttribute('section-id', sectionId);
            currentVariantPicker.setAttribute('context', context);
            currentVariantPicker.setAttribute('handle', handle);
            if (updateUrl) {
              currentVariantPicker.setAttribute('update-url', '');
            }
            
            // Disparar evento para reinicializar el variant-picker
            currentVariantPicker.dispatchEvent(new CustomEvent('variant-picker:update', { bubbles: true }));
          }
          
          // 3. Actualizar SKU
          const newSku = doc.querySelector('variant-sku');
          const currentSku = document.querySelector('variant-sku');
          if (newSku && currentSku) {
            currentSku.innerHTML = newSku.innerHTML;
          } else if (newSku && !currentSku) {
            // Si no existe, buscar dónde insertarlo
            const skuContainer = document.querySelector('.product-info__block-item[data-block-type="sku"]');
            if (skuContainer) {
              skuContainer.innerHTML = newSku.outerHTML;
            }
          } else if (!newSku && currentSku) {
            // Si el nuevo producto no tiene SKU, ocultar o remover
            currentSku.style.display = 'none';
          }
          
          // 4. Actualizar título del producto
          const newTitle = doc.querySelector('.product-title, h1.product-title, .product-info__title');
          const currentTitle = document.querySelector('.product-title, h1.product-title, .product-info__title');
          if (newTitle && currentTitle) {
            currentTitle.innerHTML = newTitle.innerHTML;
          }
          
          // 5. Actualizar precios
          const newPriceList = doc.querySelector('price-list');
          const currentPriceList = document.querySelector('price-list');
          if (newPriceList && currentPriceList) {
            currentPriceList.innerHTML = newPriceList.innerHTML;
          }
          
          // 6. Actualizar formulario del producto (variante seleccionada)
          const newForm = doc.querySelector(`form#${currentVariantPicker?.getAttribute('form-id')}`);
          const currentForm = document.querySelector(`form#${currentVariantPicker?.getAttribute('form-id')}`);
          if (newForm && currentForm) {
            // Actualizar el input hidden de variante
            const newVariantInput = newForm.querySelector('input[name="id"]');
            const currentVariantInput = currentForm.querySelector('input[name="id"]');
            if (newVariantInput && currentVariantInput) {
              currentVariantInput.value = newVariantInput.value;
              // Disparar evento de cambio para actualizar otros componentes
              currentVariantInput.dispatchEvent(new Event('change', { bubbles: true }));
            }
          }
          
          // 7. Actualizar product-rerender si existe
          const newProductRerender = doc.querySelector('product-rerender');
          if (newProductRerender && productRerender) {
            // Actualizar solo el contenido interno, no el elemento completo
            const newContent = newProductRerender.querySelector('.product');
            const currentContent = productRerender.querySelector('.product');
            if (newContent && currentContent) {
              // Actualizar galería si existe
              const newGalleryInRerender = newContent.querySelector('product-gallery');
              const currentGalleryInRerender = currentContent.querySelector('product-gallery');
              if (newGalleryInRerender && currentGalleryInRerender) {
                currentGalleryInRerender.innerHTML = newGalleryInRerender.innerHTML;
              }
              
              // Actualizar product-info completo (incluyendo todos los metafields)
              const newProductInfo = newContent.querySelector('.product-info');
              const currentProductInfo = currentContent.querySelector('.product-info');
              if (newProductInfo && currentProductInfo) {
                // Actualizar todos los bloques de product-info para asegurar que los metafields se actualicen
                const newBlocks = newProductInfo.querySelectorAll('.product-info__block-item');
                const currentBlocks = currentProductInfo.querySelectorAll('.product-info__block-item');
                
                // Crear un mapa de bloques actuales por block-id
                const currentBlocksMap = new Map();
                currentBlocks.forEach(block => {
                  const blockId = block.getAttribute('data-block-id');
                  if (blockId) {
                    currentBlocksMap.set(blockId, block);
                  }
                });
                
                // Actualizar o agregar/remover bloques
                newBlocks.forEach(newBlock => {
                  const blockId = newBlock.getAttribute('data-block-id');
                  const blockType = newBlock.getAttribute('data-block-type');
                  
                  if (blockId && currentBlocksMap.has(blockId)) {
                    // El bloque existe, actualizarlo
                    const currentBlock = currentBlocksMap.get(blockId);
                    currentBlock.innerHTML = newBlock.innerHTML;
                    
                    // Si es un variant-picker, mantener los atributos necesarios
                    if (blockType === 'variant-picker') {
                      const newVariantPicker = newBlock.querySelector('variant-picker');
                      const currentVariantPicker = currentBlock.querySelector('variant-picker');
                      if (newVariantPicker && currentVariantPicker) {
                        const formId = currentVariantPicker.getAttribute('form-id');
                        const sectionId = currentVariantPicker.getAttribute('section-id');
                        const context = currentVariantPicker.getAttribute('context');
                        const handle = currentVariantPicker.getAttribute('handle');
                        const updateUrl = currentVariantPicker.hasAttribute('update-url');
                        
                        currentVariantPicker.setAttribute('form-id', formId);
                        currentVariantPicker.setAttribute('section-id', sectionId);
                        currentVariantPicker.setAttribute('context', context);
                        currentVariantPicker.setAttribute('handle', handle);
                        if (updateUrl) {
                          currentVariantPicker.setAttribute('update-url', '');
                        }
                      }
                    }
                  } else if (blockId) {
                    // El bloque no existe, agregarlo
                    // Buscar dónde insertarlo (después del último bloque o al final)
                    const lastBlock = Array.from(currentBlocks).pop();
                    if (lastBlock && lastBlock.parentNode) {
                      lastBlock.parentNode.insertBefore(newBlock.cloneNode(true), lastBlock.nextSibling);
                    } else if (currentProductInfo) {
                      currentProductInfo.appendChild(newBlock.cloneNode(true));
                    }
                  }
                });
                
                // Remover bloques que ya no existen en el nuevo producto
                currentBlocks.forEach(currentBlock => {
                  const blockId = currentBlock.getAttribute('data-block-id');
                  if (blockId) {
                    const existsInNew = Array.from(newBlocks).some(newBlock => 
                      newBlock.getAttribute('data-block-id') === blockId
                    );
                    if (!existsInNew) {
                      // El bloque ya no existe, removerlo o ocultarlo
                      currentBlock.style.display = 'none';
                      // O removerlo completamente si prefieres:
                      // currentBlock.remove();
                    }
                  }
                });
                
                // También actualizar los colores relacionados si existen
                const newColorList = newProductInfo.querySelector('.product-info__related-colors');
                const currentColorList = currentProductInfo.querySelector('.product-info__related-colors');
                if (newColorList && currentColorList) {
                  currentColorList.innerHTML = newColorList.innerHTML;
                } else if (newColorList && !currentColorList) {
                  // Si el nuevo producto tiene colores pero el actual no, agregarlo antes del variant-picker
                  const variantPickerBlock = currentProductInfo.querySelector('.product-info__block-item[data-block-type="variant-picker"]');
                  if (variantPickerBlock && variantPickerBlock.parentNode) {
                    variantPickerBlock.parentNode.insertBefore(newColorList.cloneNode(true), variantPickerBlock);
                  }
                } else if (!newColorList && currentColorList) {
                  // Si el nuevo producto no tiene colores pero el actual sí, removerlo
                  currentColorList.remove();
                }
                
                // Actualizar variant-inventory (stock) después de actualizar los bloques
                // Esto asegura que el stock se actualice correctamente
                const newInventory = newProductInfo.querySelector('variant-inventory');
                const currentInventory = currentProductInfo.querySelector('variant-inventory');
                if (newInventory && currentInventory) {
                  currentInventory.innerHTML = newInventory.innerHTML;
                  // Actualizar atributos si existen
                  if (newInventory.hasAttribute('aria-valuenow')) {
                    currentInventory.setAttribute('aria-valuenow', newInventory.getAttribute('aria-valuenow'));
                  }
                  // Actualizar progress-bar si existe
                  const newProgressBar = newInventory.querySelector('progress-bar');
                  const currentProgressBar = currentInventory.querySelector('progress-bar');
                  if (newProgressBar && currentProgressBar) {
                    currentProgressBar.setAttribute('aria-valuenow', newProgressBar.getAttribute('aria-valuenow') || '0');
                    currentProgressBar.setAttribute('aria-valuemax', newProgressBar.getAttribute('aria-valuemax') || '50');
                  }
                }
                
                // Actualizar quantity-selector si existe (puede estar limitado por stock)
                const newQuantitySelector = newProductInfo.querySelector('quantity-selector');
                const currentQuantitySelector = currentProductInfo.querySelector('quantity-selector');
                if (newQuantitySelector && currentQuantitySelector) {
                  // Actualizar el max si está limitado por stock
                  const newMax = newQuantitySelector.getAttribute('max');
                  if (newMax) {
                    currentQuantitySelector.setAttribute('max', newMax);
                  }
                }
              }
            }
          }
          
          // 8. Actualizar URL sin recargar (usando history API)
          if (window.history) {
            window.history.pushState({}, '', productUrl);
          }
          
          // 9. Actualizar variant-inventory (stock) en toda la página
          const newInventory = doc.querySelector('variant-inventory');
          const currentInventory = document.querySelector('variant-inventory');
          if (newInventory && currentInventory) {
            currentInventory.innerHTML = newInventory.innerHTML;
            // Actualizar atributos si existen
            if (newInventory.hasAttribute('aria-valuenow')) {
              currentInventory.setAttribute('aria-valuenow', newInventory.getAttribute('aria-valuenow'));
            }
            // Actualizar progress-bar si existe
            const newProgressBar = newInventory.querySelector('progress-bar');
            const currentProgressBar = currentInventory.querySelector('progress-bar');
            if (newProgressBar && currentProgressBar) {
              currentProgressBar.setAttribute('aria-valuenow', newProgressBar.getAttribute('aria-valuenow') || '0');
              currentProgressBar.setAttribute('aria-valuemax', newProgressBar.getAttribute('aria-valuemax') || '50');
            }
          }
          
          // 10. Disparar evento de cambio de variante para actualizar componentes que dependen del stock
          const variantIdInput = document.querySelector('input[name="id"]');
          if (variantIdInput) {
            // Disparar evento de cambio para que variant-inventory y otros componentes se actualicen
            variantIdInput.dispatchEvent(new CustomEvent('change', { bubbles: true }));
            
            // También disparar evento variant:change si el tema lo usa
            const variantChangeEvent = new CustomEvent('variant:change', {
              bubbles: true,
              detail: {
                variant: {
                  id: variantIdInput.value
                }
              }
            });
            document.dispatchEvent(variantChangeEvent);
          }
          
          // 11. Disparar eventos personalizados para que otros componentes se actualicen
          document.dispatchEvent(new CustomEvent('product:updated', { 
            detail: { productUrl: productUrl },
            bubbles: true 
          }));
          
          // Restaurar opacidad
          if (productRerender) {
            productRerender.style.opacity = '';
            productRerender.style.pointerEvents = '';
          }
        })
        .catch(error => {
          console.error('Error fetching product:', error);
          // Restaurar opacidad en caso de error
          if (productRerender) {
            productRerender.style.opacity = '';
            productRerender.style.pointerEvents = '';
          }
        });
      
      return; // No continuar con la lógica de tarjetas
    }
    
    if (!productCard) return;
    
    // Guardar la variante original ANTES de cambiar de color
    // Esta es la variante que estaba seleccionada cuando se cargó la página
    const productFormInitial = productCard.querySelector('form[action*="/cart/add"]');
    const variantIdInputInitial = productFormInitial?.querySelector('input[name="id"]');
    const originalVariantId = variantIdInputInitial?.value || null;
    
    // También guardar el ID del producto original (el que está en la tarjeta inicialmente)
    // Esto lo podemos obtener del atributo handle del product-card o del primer script tag
    const originalProductId = productCard.getAttribute('handle') ? 
      // Si tenemos handle, buscar el script tag del producto original
      (() => {
        const firstScript = productCard.querySelector('script[data-color-product-data]');
        return firstScript ? firstScript.getAttribute('data-color-product-data') : null;
      })() : null;

    // Parsear datos del producto desde JSON
    const productId = colorSwatch.dataset.productId;
    let product, options, variants;
    
    try {
      // Buscar el script tag con los datos del producto
      const productDataScript = productCard.querySelector(`script[data-color-product-data="${productId}"]`);
      if (productDataScript) {
        const productData = JSON.parse(productDataScript.textContent);
        product = productData.product;
        options = productData.options;
        variants = productData.variants;
      } else {
        // Fallback: intentar desde data attributes (puede fallar con JSON complejo)
        const productDataAttr = colorSwatch.getAttribute('data-product');
        if (productDataAttr) {
          product = JSON.parse(productDataAttr);
        } else {
          console.error('No product data found');
          return;
        }
      }
    } catch (error) {
      console.error('Error parsing product data:', error);
      return;
    }

    // Remover clase is-selected de todos los swatches en esta tarjeta
    const allSwatches = productCard.querySelectorAll('a[data-color-swatch="true"]');
    allSwatches.forEach(swatch => swatch.classList.remove('is-selected'));
    
    // Agregar clase is-selected al swatch clickeado
    colorSwatch.classList.add('is-selected');
    
    // 1. Actualizar título del producto
    const titleElement = productCard.querySelector('.product-title');
    if (titleElement && product.title) {
      titleElement.textContent = product.title;
      titleElement.href = colorSwatch.dataset.productUrl;
    }

    // 2. Actualizar enlaces
    const mediaLink = productCard.querySelector('.product-card__media');
    if (mediaLink && colorSwatch.dataset.productUrl) {
      mediaLink.href = colorSwatch.dataset.productUrl;
    }

    // 3. Actualizar imágenes
    const productImage = colorSwatch.dataset.productImage;
    const productImageSecondary = colorSwatch.dataset.productImageSecondary;
    
    if (productImage) {
      const mainImage = productCard.querySelector('.product-card__image--primary');
      if (mainImage && mainImage.tagName === 'IMG') {
        mainImage.src = productImage;
        mainImage.srcset = productImage;
      }
      
      if (productImageSecondary) {
        const secondaryImage = productCard.querySelector('.product-card__image--secondary');
        if (secondaryImage && secondaryImage.tagName === 'IMG') {
          secondaryImage.src = productImageSecondary;
          secondaryImage.srcset = productImageSecondary;
        }
      }
    }

    // 4. Actualizar precios
    const priceList = productCard.querySelector('price-list');
    if (priceList && product) {
      // Obtener la primera variante disponible o la primera variante
      const firstVariant = product.variants?.find(v => v.available) || product.variants?.[0];
      
      if (firstVariant) {
        const price = firstVariant.price || 0;
        const comparePrice = firstVariant.compare_at_price || 0;

        // Formatear precios usando el formato de Shopify (cents)
        const formatMoney = (cents) => {
          // Intentar usar el formato de Shopify si está disponible
          if (window.Shopify?.format?.money) {
            try {
              return window.Shopify.format.money(cents);
            } catch (e) {
              // Continuar con fallback
            }
          }
          
          // Fallback: usar formato estándar
          const currencyCode = window.Shopify?.currency?.active || 
                              document.documentElement.lang?.split('-')[1]?.toUpperCase() || 
                              'EUR';
          
          return new Intl.NumberFormat('es-ES', {
            style: 'currency',
            currency: currencyCode
          }).format(cents / 100);
        };

        // Actualizar precio principal (sale-price)
        const salePriceElement = priceList.querySelector('sale-price');
        if (salePriceElement) {
          salePriceElement.textContent = formatMoney(price);
          // Actualizar clases según si está en oferta
          if (comparePrice > price) {
            salePriceElement.className = salePriceElement.className.replace(/text-subdued/g, 'text-on-sale');
          } else {
            salePriceElement.className = salePriceElement.className.replace(/text-on-sale/g, 'text-subdued');
          }
        }

        // Actualizar precio comparado (compare-at-price)
        let comparePriceElement = priceList.querySelector('compare-at-price');
        if (comparePrice > price) {
          if (!comparePriceElement) {
            // Crear elemento si no existe
            comparePriceElement = document.createElement('compare-at-price');
            comparePriceElement.className = 'text-subdued line-through';
            if (salePriceElement) {
              salePriceElement.after(comparePriceElement);
            } else {
              priceList.appendChild(comparePriceElement);
            }
          }
          comparePriceElement.textContent = formatMoney(comparePrice);
          comparePriceElement.style.display = '';
        } else if (comparePriceElement) {
          comparePriceElement.style.display = 'none';
        }
      }
    }

    // 5. Actualizar opciones (tallas) y variantes
    // options y variants ya fueron parseados arriba

    // Actualizar formulario de compra rápida
    const productForm = productCard.querySelector('form[action*="/cart/add"]');
    if (productForm && variants && variants.length > 0) {
      // Actualizar input hidden de variante
      const variantIdInput = productForm.querySelector('input[name="id"]');
      let selectedVariantId = null;
      let originalVariant = null;
      
      // Buscar la variante original del producto inicial
      // La variante original es la que estaba seleccionada ANTES de cambiar de color
      if (originalVariantId) {
        // Buscar en todos los scripts de productos para encontrar la variante original
        const allProductDataScripts = productCard.querySelectorAll('script[data-color-product-data]');
        
        for (const script of allProductDataScripts) {
          try {
            const productDataParsed = JSON.parse(script.textContent);
            const foundVariant = productDataParsed.variants?.find(v => 
              v.id.toString() === originalVariantId.toString()
            );
            
            if (foundVariant) {
              originalVariant = foundVariant;
              break; // Encontramos la variante, salir del loop
            }
          } catch (e) {
            // Continuar con el siguiente script
          }
        }
      }
      
      // Determinar qué variante seleccionar
      // Si el producto seleccionado ES el producto original, usar su primera variante disponible
      // Si el producto seleccionado NO es el original, usar la variante original si está disponible
      const isOriginalProduct = product.id.toString() === originalProductId;
      
      if (isOriginalProduct) {
        // Si seleccionamos el producto original, usar su primera variante disponible
        const firstAvailableVariant = variants.find(v => v.available) || variants[0];
        if (firstAvailableVariant) {
          selectedVariantId = firstAvailableVariant.id;
          if (variantIdInput) {
            variantIdInput.value = selectedVariantId.toString();
          }
        }
      } else {
        // Si seleccionamos un producto relacionado, usar la variante original si está disponible
        if (originalVariant && originalVariant.available) {
          selectedVariantId = originalVariant.id;
          if (variantIdInput) {
            variantIdInput.value = selectedVariantId.toString();
          }
        } else {
          // Si no, usar la primera variante disponible del nuevo producto
          const firstAvailableVariant = variants.find(v => v.available) || variants[0];
          if (firstAvailableVariant) {
            selectedVariantId = firstAvailableVariant.id;
            if (variantIdInput) {
              variantIdInput.value = selectedVariantId.toString();
            }
          }
        }
      }

      // Actualizar botones de tallas si existen
      const sizeContainer = productForm.querySelector('[data-size-container]');
      if (sizeContainer && options) {
        // Debug: mostrar todas las opciones disponibles
        console.log('Available options:', options.map(op => ({ name: op.name, position: op.position, values: op.values })));
        
        // Encontrar la opción de talla (case-insensitive y múltiples variaciones)
        let sizeOption = options.find(op => {
          if (!op || !op.name) return false;
          const opNameLower = op.name.toLowerCase().trim();
          // Verificar coincidencias exactas (incluyendo variaciones en español)
          const exactMatches = ['size', 'talla', 'tallas', 'taille', 'tamaño', 'tamaños', 'tamano', 'tamanos'];
          return exactMatches.includes(opNameLower);
        });
        
        // Si no se encuentra por nombre, intentar usar la posición desde el input hidden
        if (!sizeOption) {
          const sizeOptionInput = productForm.querySelector('.mox-size-option-input');
          if (sizeOptionInput) {
            const sizeOptionName = sizeOptionInput.getAttribute('name'); // ej: "option1", "option2", etc.
            if (sizeOptionName && sizeOptionName.startsWith('option')) {
              const position = parseInt(sizeOptionName.replace('option', ''));
              sizeOption = options.find(op => op.position === position);
              console.log('Found size option by input name:', sizeOptionName, 'position:', position, 'option:', sizeOption);
            }
          }
        }
        
        // Si aún no se encuentra, buscar cualquier opción que no sea color
        if (!sizeOption && options.length > 0) {
          const colorNames = ['color', 'colour', 'colore', 'cor', 'colores', 'color', 'couleur'];
          const nonColorOptions = options.filter(op => {
            if (!op || !op.name) return false;
            const opNameLower = op.name.toLowerCase().trim();
            return !colorNames.includes(opNameLower);
          });
          
          if (nonColorOptions.length > 0) {
            sizeOption = nonColorOptions[0];
            console.log('Using non-color option as size:', sizeOption);
          }
        }
        
        console.log('Final size option:', sizeOption ? { name: sizeOption.name, position: sizeOption.position, values: sizeOption.values } : 'NOT FOUND');

        if (sizeOption && sizeOption.values) {
          // Limpiar contenedor de tallas
          sizeContainer.innerHTML = '';

          // PRIMERO: Agregar la variante original si existe y está disponible
          console.log('Checking original variant:', {
            originalVariant,
            originalVariantId,
            hasOriginal: !!originalVariant,
            isAvailable: originalVariant?.available
          });
          
          if (originalVariant && originalVariant.available) {
            const originalSizeValue = originalVariant.options?.[sizeOption.position - 1];
            console.log('Adding original variant button:', {
              originalSizeValue,
              variantId: originalVariant.id,
              options: originalVariant.options
            });
            
            if (originalSizeValue) {
              const originalSizeButton = document.createElement('button');
              originalSizeButton.type = 'submit';
              originalSizeButton.className = 'mox-card-size-overlay__size is-selected';
              originalSizeButton.textContent = originalSizeValue;
              originalSizeButton.dataset.variantId = originalVariant.id;
              originalSizeButton.dataset.colorValue = product.id; // ID del producto original
              originalSizeButton.setAttribute('aria-pressed', 'true');
              
              // Agregar event listener
              originalSizeButton.addEventListener('click', function(e) {
                // Remover selección de otros botones
                const allSizeButtons = sizeContainer.querySelectorAll('.mox-card-size-overlay__size');
                allSizeButtons.forEach(btn => {
                  btn.classList.remove('is-selected');
                  btn.removeAttribute('aria-pressed');
                });
                
                // Marcar este como seleccionado
                originalSizeButton.classList.add('is-selected');
                originalSizeButton.setAttribute('aria-pressed', 'true');
                
                // Actualizar input
                if (variantIdInput) {
                  variantIdInput.value = originalVariant.id.toString();
                }
                
                // Actualizar precio
                updatePriceForVariant(priceList, originalVariant);
              });
              
              sizeContainer.appendChild(originalSizeButton);
            }
          }

          // SEGUNDO: Crear botones de tallas para el nuevo producto - SOLO DISPONIBLES
          sizeOption.values.forEach((sizeValue) => {
            // Buscar variante que tenga esta talla Y esté disponible
            const variantWithSize = variants.find(v => {
              const sizeIndex = sizeOption.position - 1;
              return v.available && v.options && v.options[sizeIndex] === sizeValue;
            });

            // Solo crear botón si la variante está disponible
            // Y si no es la misma que la original (para evitar duplicados)
            if (variantWithSize && variantWithSize.available) {
              // Verificar que no sea la misma variante que la original
              const isOriginalVariant = originalVariant && 
                variantWithSize.id.toString() === originalVariant.id.toString();
              
              if (!isOriginalVariant) {
                const sizeButton = document.createElement('button');
                sizeButton.type = 'submit';
                sizeButton.className = 'mox-card-size-overlay__size';
                sizeButton.textContent = sizeValue;
                sizeButton.dataset.variantId = variantWithSize.id;
                sizeButton.dataset.colorValue = colorSwatch.dataset.productId;
                
                // Marcar como seleccionado si es la variante actualmente seleccionada
                const isSelected = selectedVariantId && !originalVariant && (
                  variantWithSize.id.toString() === selectedVariantId.toString() ||
                  parseInt(variantWithSize.id) === parseInt(selectedVariantId)
                );
                
                if (isSelected) {
                  sizeButton.classList.add('is-selected');
                  sizeButton.setAttribute('aria-pressed', 'true');
                }
              
              
              // Agregar event listener
              sizeButton.addEventListener('click', function(e) {
                // Remover clase is-selected de todos los botones de talla
                const allSizeButtons = sizeContainer.querySelectorAll('.mox-card-size-overlay__size');
                allSizeButtons.forEach(btn => {
                  btn.classList.remove('is-selected');
                  btn.removeAttribute('aria-pressed');
                });
                
                // Agregar clase is-selected al botón clickeado
                sizeButton.classList.add('is-selected');
                sizeButton.setAttribute('aria-pressed', 'true');
                
                // Asegurar que el input se actualice ANTES del submit
                if (variantIdInput) {
                  variantIdInput.value = variantWithSize.id.toString();
                }
                
                // Actualizar precio
                updatePriceForVariant(priceList, variantWithSize);
                
                // El listener global actualizará el input[name="id"] y el formulario se enviará
              });

              sizeContainer.appendChild(sizeButton);
              }
            }
          });
        }
      }
    }
  });
})();
